import { TransportMode } from './transport-mode.enum';

export class TransportModeCardModel {
  transportMode = TransportMode.Unknown;
  title = '';
  text = '';
  buttonText = '';
}
